export const chatFeatureKey = ['chat'] as const;
